// extracted by mini-css-extract-plugin
export default {"industries":"industry_industries__i1GMo","industryList":"industry_industryList__AcX3N","app-content":"industry_app-content__O-ATL"};